export const locale = {
	base: {
		exportData: 'მონაცემების ექსპორტი',
		sender: 'გამგზავნი',
		general: 'გენერალი',
		aprove: 'ადასტურება',
		subscribe: 'გამოწერა',
		unsubscribe: 'გამოწერის გაუქმება',
		toSubscriptions: 'ხელმოწერებზე',
		subscribtions: 'ხელმოწერებზე',
		colleagues: 'კოლეგები',
		search: 'ძებნა',
		doNotMiss: 'არ გამოტოვოთ დღეს',
		searchMain: 'სიახლეების, თანამშრომლების, მოვლენების ძებნა',
		emptyList: 'ცარიელი სია',
		publish: 'გამოქვეყნება',
		unlock: 'ბლოკის მოხსნა',
		published: 'გამოქვეყნება',
		rejected: 'უარყოფა',
		send: 'გაგზავნა',
		saveAsDraft: 'მონახაზის სახით შენახვა',
		save: 'შენახვა',
		select: 'არჩევა',
		noData: 'მონაცემები არ მოიპოვება',
		toMain: 'მთავარზე',
		myArticles: 'ჩემი პუბლიკაციები',
		myDrafts: 'ჩემი მონახაზები ',
		exit: 'გასვლა',
		edit: 'რედაქტირება',
		delete: 'წაშლა',
		close: 'დახურვა',
		leave: 'გასვლა',
		more: 'მეტი',
		add: 'დამატება',
		showMore: 'მეტის ჩვენება',
		hideMore: 'დამალვა',
		answer: '0 პასუხი | {n} პასუხი | {n} პასუხი | {n} პასუხი',
		category: '0 კატეგორია | {n} კატეგორია | {n} კატეგორია | {n} კატეგორია',
		clustery: '0 რეგიონი | {n} რეგიონი | {n} რეგიონი | {n} რეგიონი',
		user: '0 მომხმარებელი | {და} მომხმარებელი | {ში} მომხმარებელი | {და} მომხმარებელი',
		categories: 'კატეგორია',
		clusters: 'რეგიონები',
		clusterOne: 'რეგიონი',
		categoryOne: 'კატეგორია',
		answered: 'პასუხგაცემულია',
		upload: 'ატვირთვა',
		uploadFile: 'ფაილის ატვირთვა',
		uploadImg: 'გამოსახულების ატვირთვა',
		supportedFormats: 'დასაშვები ფორმატები: {value}.',
		supportedSize: 'დასაშვები ზომა: {value}.',
		maxFileSize: 'მაქსიმალური ზომა: {value}მბ',
		minimumResolution: 'მინიმალური გარჩევადობა: {value}.',
		fileUploaded: 'ფაილი ატვირთულია',
		yes: 'დიახ',
		no: 'არა',
		maybe: 'შესაძლებელია',
		join: 'შემოგვიერთდი',
		tune: 'პარამეტრები',
		result: 'შედეგი',
		congratulate: 'მილოცვა',
		congratulation: 'მილოცვა',
		actions: 'მოქმედება',
		commentOrigin: 'კომენტარი',
		writeComment: 'კომენტარის დაწერა..',
		department: 'დეპარტამენტი',
		create: 'შექმნა',
		articleModerationEnabled: 'სიახლეების მოდერაცია',
		cancel: 'გაუქმება',
		cancel2: 'გაუქმება',
		comment: '0 კომენტარი | {n} კომენტარი | {n} კომენტარი | {n} კომენტარი',
		seeComments: 'სხვა კომენტარების ჩვენება',
		reply: 'პასუხი',
		myProfile: 'ჩემი პროფილი',
		profileSetting: 'პროფილის პარამეტრები',
		companyStructure: 'კომპანიის სტრუქტურა',
		businessTrips: 'Ბიზნეს მოგზაურობა',
		portal: 'პორტალი',
		adminPanel: 'ადმინ-პანელი',
		never: 'არასოდეს',
		date: 'თარიღი',
		time: 'დრო',
		after: 'შემდეგ',
		liked: 'მოწონებული',
		selectDate: 'თარიღის არჩევა',
		times: '-ჯერ',
		subTitleDocuments: 'სუბტიტრები დოკუმენტებისთვის',
		subTitle: 'ქვესათაური',
		sizes: ['ბაიტი', 'კბ', 'მბ', 'გბ'],
		cluster: 'რეგიონი',
		timezoneInfo: 'დრო აისახება სასაათო სარტყელში Europe GMT +3:00',
		saveData: 'მონაცემები წარმატებით შეინახა',
		icons: 'პიქტოგრამები',
		icon: 'პიქტოგრამა',
		share: 'გაზიარება',
		enterName: 'შეიყვანეთ სათაური',
		sum: 'ჯამი',
		currency: 'ვალუტა',
		rate: 'კარგად',
		noItemsByParams: 'მითითებულ პარამეტრებზე შედეგი ვერ მოიძებნა.',
		deleteNotAvailable: 'შეუძლებელია წაშლა - ელემენტი უკვე გამოიყენება.',
		byDefault: 'ნაგულისხმევი',
		others: 'სხვა',
		ok: 'კარგი',
		filter: 'ფილტრი',
		filters: 'ფილტრები',
		apply: 'მიმართეთ',
		clear: 'წმინდა',
		enterLocation: 'შეიყვანეთ ადგილმდებარეობა'
	},
	userPerformance: {
		infoBlock1: 'პროცესის ინსტრუქციები',
    infoBlock2: 'KPI სტატუსების ფორმები და საჭირო ქმედებები',
    btnCreate: 'შექმენით KPI ფორმა',
		faq1: 'როგორ შეავსოთ KPI ფორმა? {link}',
		faqText1: '(ვიდეო)',
    faq2: 'KPI ფორმის დამტკიცება (მენეჯერებისთვის) {link}',
		faqText2: '(ვიდეო)',
    faq3: 'პროცესის ზოგადი ინსტრუქციები {link}',
		faqText3: '(pdf)',
		table: {
			id: 'ID',
			user: 'თანამშრომელი',
			company: 'კომპანიის სახელი',
			position: 'პოზიცია',
			positionLevel: 'პოზიციის დონე',
			mustApproveBy: 'უნდა ივარჯიშო',
			year: 'შეფასების წელი',
			cbAdmin: 'C&B ადმინისტრატორი',
			disallowEdit: 'რედაქტირების გამორთვა',
			allowEdit: 'რედაქტირების დაშვება',
			status: 'სტატუსი',
		},
		status: {
			draft: 'მონახაზი',
			draftDesc: 'ფორმა შენახულია, მაგრამ ჯერ არ არის გაგზავნილი დასამტკიცებლად',
			not_approved: 'არ არის დამტკიცებული',
			not_approvedDesc: 'მენეჯერმა KPI ფორმა გადასახედად დააბრუნა, ხელქვეითს ცვლილებების შეტანა და ფორმის ხელახლა გაგზავნა მენეჯერისთვის დასამტკიცებლად სჭირდება.',
			approved_by_user: 'მომხმარებლის მიერ დამტკიცებული',
			approved_by_userDesc: 'ფორმა გაიგზავნა, საჭიროა მენეჯერის თანხმობა',
			approved_by_manager: 'მენეჯერის მიერ დამტკიცებული',
			approved_by_managerDesc: 'მენეჯერმა ფორმაში ცვლილებები შეიტანა, დაქვემდებარებულმა უნდა დაეთანხმოს ცვლილებებს თავისი მხრიდან',
			approved_by_manager_cb: 'დამტკიცებულია ადმინისტრატორის მიერ',
			approved_by_manager_cbDesc: 'C&B ადმინისტრატორმა დაამტკიცა ფორმა, პროცესი დასრულებულია',
      approved_by_both_side: 'ორივე მხარის მიერ შეთანხმებული',
      approved_by_both_sideDesc: 'ფორმა შეთანხმებულია მენეჯერისა და დაქვემდებარებულის მიერ და იგზავნება ადმინისტრატორის C&B განყოფილებაში.',

		},
		form: {
			dataForm: 'მონაცემთა შეყვანის ფორმა',
			tableForm: 'KPI-ის დაყენების ფორმა',
			user: 'სრული სახელი',
			company: 'კომპანიის სახელი',
			department: 'ერთეული',
			position: 'პოზიცია',
			positionLevel: 'პოზიციის დონე',
			period: 'შეფასების პერიოდი',
			year: 'შეფასების წელი',
			submitBtn: 'დადასტურება',
			declineBtn: 'უარყოფა',
			saveDraftBtn: 'შავი ვარიანტის შენახვა',
		},
		selectPeriod: {
			year: 'წელი',
			halfYear: 'ნახევარი წელი',
			quarter: 'კვარტალი',
			month: 'თვე',
		},
		performance: {
			id: 'არ არის ხელმისაწვდომი',
			description: 'მიზნის აღწერა',
			min: 'მინიმალურად შესაძლებელია (70-90%)',
			target: 'მიზნობრივი შესრულება (91-100%)',
			over: 'გადაჭარბებული შესრულება (101-110%)',
			fact: 'ფაქტობრივი შესრულება',
			progress: 'მიღწევა',
			kpiLevel: 'KPI დონე',
			weight: 'წონა, %',
			totalPercent: 'დასრულების საერთო პროცენტული მაჩვენებელი',
			bonusPercent: 'პრემიის გაანგარიშების პროცენტი',
			addTarget: 'მიზნის დამატება',
			enter: 'შეიყვანეთ',
			addInfo: 'ინფორმაციის დამატება',
			requiredError: 'თითოეულ სტრიქონში უნდა იყოს შევსებული ველები „მიზნის აღწერა“, „წონა“ და „სამიზნე“.',
			weightError: 'წონების ჯამი 100%-ის ტოლი უნდა იყოს.'
		},
    tabs: {
      allForms: 'KPI ფორმები დასამტკიცებლად',
      myForms: 'ჩემი KPI ფორმები'
    }
	},
	positionLevel: {
		form: {
			name: 'სახელი',
			kpiLevel: 'KPI დონე',
			weight: 'წონა, %',
			enter: 'შეიყვანეთ',
		},
		table: {
			title: 'სახელი',
			level: 'KPI დონე',
			weight: 'წონა, %',
		},
		select: {
			individual: 'ინდივიდუალური KPI-ები',
			corporate: 'კორპორატიული KPI-ები',
			functional: 'ფუნქციური KPI-ები',
		}
	},
	performanceGoals: {
		menuTitle: 'КРІ',
		table: {
			uuid: 'ID',
			name: 'სახელი',
			company: 'კომპანიის სახელი',
			department: 'ერთეული',
			position: 'პოზიცია',
			positionLevel: 'პოზიციის დონე',
		},
		form: {
			company: 'კომპანიის სახელი',
			department: 'ერთეული',
			position: 'პოზიცია',
			positionLevel: 'პოზიციის დონე',
			name: 'სახელი',
			min: 'მინიმალურად შესაძლებელია (70-90%)',
			target: 'მიზნობრივი შესრულება (91-100%)',
			over: 'გადაჭარბებული შესრულება (101-110%)',
			fact: 'ფაქტობრივი შესრულება',
			progress: 'მიღწევები, %',
			kpiLevel: 'KPI დონე',
			weight: 'წონა, %',
			totalPercent: 'დასრულების საერთო პროცენტული მაჩვენებელი',
			bonusPercent: 'პრემიის გაანგარიშების პროცენტი',
			enter: 'შეიყვანეთ',
			autoCalc: 'ავტომატურად გამოითვლება',
			achievement: 'მიღწევის პროცენტული მაჩვენებელი',
		}
	},
	correspondence: {
		date: 'თარიღი',
		sender: 'გამგზავნი',
		initiator: 'ინიციატორი',
		number: 'ნომერი',
		signatory: 'ხელმომწერი',
		correspondenceType: 'ტიპი',
		documentType: 'Დოკუმენტის ტიპი',
		deliveryType: 'Ტრანსპორტირების მეთოდი',
		recipient: 'მიმღები',
		shortContent: 'მოკლე შინაარსი',
		address: 'Მისაღები მისამართი',
		cost: 'Გადაზიდვის ღირებულება',
		currency: 'ვალუტა',
		comment: 'კომენტარი',
		input: 'შემომავალი',
		output: 'დასვენების დღე',
		in: 'ში',
	},
	subscribe: {
		successNewsTitle: 'თქვენ გამოიწერეთ ახალი ამბები {name}',
		successNewsDescription: 'შეტყობინებები ახალი მომხმარებლის შესახებ {name} შეტყობინებები გაიგზავნება თქვენს ელ.',
	},
	lang: {
		ru: 'რუსული',
		en: 'ინგლისური',
		ka: 'ქართული',
		ua: 'უკრაინული',
	},
	actions: {
		create: 'შექმნა',
		remove: 'წაშლა',
		update: 'რედაქტირება',
	},
	settings: {
		articleModerationEnabled: {
			true: 'აქტიური',
			false: 'არააქტიური',
		},
	},
	statuses: {
		allStatuses: 'ყველა პუბლიკაცია',
		published: 'გამოქვეყნებული',
		rejected: 'უარყოფილი',
		draft: 'მონახაზი',
		moderation: 'მოდერაციაზე',
	},
	roles: {
		ROLE_SUPER_ADMIN: 'სუპერ ადმინისტრატორი',
		ROLE_ADMIN: 'ადმინისტრატორი',
		ROLE_LDAP_USER: 'თანამშრომელი',
	},
	businessRoles: {
		ROLE_ADMIN: 'ადმინისტრატორი',
		super_admin: 'სუპერ ადმინისტრატორი',
		budget_admin: 'ბიუჯეტის ადმინისტრატორი',
		budget_owner: 'ბიუჯეტის მფლობელი',
		administrator_c_b: 'ადმინისტრატორი C&B',
		alternate: 'მოადგილე',
		sub_budget_owner: 'ქვებიუჯეტის მფლობელი',
		hr_director: 'Ადამიანური რესურსების დირექტორი',
		administrative_manager: 'Ადმინისტრაციული მენეჯერი',
		signatory: 'ხელმომწერი',
		accountant: 'ბუღალტერი',
		hr: 'ადამიანური რესურსების დეპარტამენტი',
		employee: 'თანამშრომელი',
		all: 'ყველა როლი',
	},
	socialNetworks: {
		facebook: 'Facebook',
		instagram: 'Instagram',
		linkedin: 'LinkedIn',
		twitter: 'Twitter',
		skype: 'Skype',
		telegram: 'Telegram',
		vk: 'ვკონტაქტე',
		ok: 'ოდნოკლასნიკი',
		strava: 'Strava',
	},
	leavePage: {
		question: 'გსურთ გახვიდეთ გვერდიდან?',
		info: 'თქვენი ყველა ცვლილება დაიკარგება',
	},
	page: {
		login: 'ავტორიზაცია',
		indexNews: 'სიახლეები',
		viewNews: 'სიახლე',
		createNews: 'სიახლის შექმნა',
		createBusinessTrip: 'შექმენით საქმიანი მოგზაურობა',
		editNews: 'სიახლის რედაქტირება',
		indexNewsAdmin: 'სიახლეები',
		indexTopicAdmin: 'სიახლეების კატეგორია',
		viewTopicAdmin: 'კატეგორია',
		createTopicAdmin: 'კატეგორიის შექმნა',
		editTopicAdmin: 'კატეგორიის რედაქტირება',
		viewProfile: 'პროფილი',
		indexLogsAdmin: 'ლოგირება',
		indexBannerAdmin: 'ბანერი',
		createBannerAdmin: 'ბანერის შექმნა',
		editBannerAdmin: 'ბანერის რედაქტირება',
		indexQuizAdmin: 'კითხვარები',
		indexUsersAdmin: 'მომხმარებლები',
		createUserAdmin: 'მომხმარებლის შექმნა',
		editUserAdmin: 'მომხმარებლის რედაქტირება',
		indexSettingsAdmin: 'პარამეტრები',
		knowledgeBase: 'დოკუმენტები',
		knowledgeBasePage: 'პოლიტიკა და შაბლონები',
		indexPagesAdmin: 'გვერდები',
		createPageAdmin: 'გვერდის შექმნა',
		editPageAdmin: 'გვერდის რედაქტირება',
		indexRegionAdmin: 'რეგიონები',
		indexDictionariesAdmin: 'ლექსიკონები',
		indexPerformanceGoals: 'გოლები',
		createPerformanceGoals: 'მიზნის შექმნა',
		editPerformanceGoals: 'მიზნის რედაქტირება',
		indexPositionLevel: 'პოზიციის დონე',
		createPositionLevel: 'პოზიციის დონის შექმნა',
		editPositionLevel: 'პოზიციის დონის რედაქტირება',
		indexUserPerformance: 'შესრულების მართვა',
		createUserPerformance: 'ძირითადი მაჩვენებლები',
		editUserPerformance: 'ძირითადი მაჩვენებლები',
		indexVacations: 'წასვლა',
		createVacations: 'შვებულების შექმნა',
		editVacations: 'შვებულების რედაქტირება',
		indexCorporateResourcesAdmin: 'კორპორატიული რესურსები',
		createCorporateResourcesAdmin: 'კორპორატიული რესურსის შექმნა',
		editCorporateResourcesAdmin: 'კორპორატიული რესურსის რედაქტირება',
		indexCorrespondencesAdmin: 'საბუთების რეგისტრაცია',
		createCorrespondencesAdmin: 'კორესპონდენციის ტიპის შექმნა',
		editCorrespondencesAdmin: 'კორესპონდენციის რედაქტირება',
		indexPageCategoriesAdmin: 'გვერდების კატეგორიები',
		createPageCategoriesAdmin: 'გვერდის კატეგორიის შექმნა',
		editPageCategoriesAdmin: 'გვერდის კატეგორიის რედაქტირება',
		indexDocumentTypesAdmin: 'Დოკუმენტის ტიპი',
		createDocumentTypesAdmin: 'დოკუმენტის ტიპის შექმნა',
		editDocumentTypesAdmin: 'დოკუმენტის ტიპის რედაქტირება',
		indexDocumentCategoriesAdmin: 'დეპარტამენტი',
		createDocumentCategoriesAdmin: 'განყოფილების შექმნა',
		editDocumentCategoriesAdmin: 'რედაქტირების განყოფილება',
		indexShippingMethodsAdmin: 'Ტრანსპორტირების მეთოდი',
		createShippingMethodsAdmin: 'შექმენით გადაზიდვის მეთოდი',
		editShippingMethodsAdmin: 'მიწოდების მეთოდის რედაქტირება',
		indexSubmittingBudgets: 'ბიუჯეტების წარდგენა',
		indexDriversAdmin: 'მძღოლები',
		createDriversAdmin: 'მძღოლის ბარათის შექმნა',
		editDriversAdmin: 'მძღოლის ბარათის რედაქტირება',
		driversSchedule: 'მძღოლების დაჯავშნა',
		indexHallsAdmin: 'დარბაზები',
		createHallsAdmin: 'დარბაზის შექმნა',
		editHallsAdmin: 'დარბაზის რედაქტირება',
		hallsReservation: 'დარბაზის დაჯავშნა',
		greetingAdmin: 'მისალმება',
		events: 'ღონისძიებები',
		correspondence: 'მიმოწერა',
		correspondenceCategory: 'მიმოწერა {category}',
		createEvent: 'ღონისძიების შექმნა',
		editEvent: 'ღონისძიების რედაქტირება',
		editBusinessTrip: 'აპლიკაციის რედაქტირება',
		indexSearch: 'ძებნა',
		'about-company': 'კომპანიის შესახებ',
		'about-products': 'პროდუქციის შესახებ',
		'company-structure': 'კომპანიის სტრუქტურა',
		collaboration: 'კოლაბორაცია',
		welcome: 'კეთილი იყოს თქვენი მობრძანება',
		404: '404',
		policy: 'პორტალის გამოყენების პირობები',
		viewBusinessTrips: 'Ბიზნეს მოგზაურობა',
	},
	subscribtions: {
		noUsers: 'თქვენ ამჟამად არ ხართ გამოწერილი თქვენს კოლეგებზე.',
	},
	error: {
		404: {
			title: 'ასეთი გვერდი ვერ მოიძებნა:(',
			desc: 'გვერდი შესაძლოა წაიშალა ან შეიცვალა მისამართი',
			btn: 'მთავარზე გადასვლა',
		},
    kpi: {
      title: 'KPI ფორმა წაშლილია :(',
      desc: 'თუ ეს შეცდომაა, გთხოვთ, დაუკავშირდეთ ადმინისტრატორს',
    }
	},
	createUser: {
		form: {
			firstName: 'სახელი',
			lastName: 'გვარი',
			email: 'ელფოსტა',
			password: 'პაროლი',
			country: 'ქვეყანა',
			company: 'კომპანია',
		},
		placeholder: {
			firstName: 'შეიყვანეთ სახელი',
			lastName: 'შეიყვანეთ გვარი',
			email: 'შეიყვანეთ ელფოსტა',
			password: 'შეიყვანეთ პაროლი',
			country: 'შეიყვანეთ ქვეყანა',
			company: 'შეიყვანეთ კომპანია',
		},
	},
	modal: {
		areYouSureToDelete: 'დარწმუნებული ხართ, რომ გსურთ წაშლა?',
		areYouSureToCancelTrip: 'დარწმუნებული ხართ, რომ გსურთ მოგზაურობის გაუქმება?',
		areYouSureToCancel: 'დარწმუნებული ხართ, რომ გსურთ გაუქმება?',
		areYouSureToCancelEntry: 'დარწმუნებული ხართ, რომ გსურთ შესვლის გაუქმება?',
		deletingTextModal: 'რეგიონის წაშლა',
		areLongTime: 'პროცესს შესაძლოა დიდი დრო დასჭირდეს..',
	},
	indexNews: {
		new: 'სიახლე',
		likedNew:'არ მოეწონა | მოეწონა {n} ადამიანს | მოეწონა {n} ადამიანს | მოეწონა {n} ადამიანს '
	},
	greeting: {
		show: 'მისალმების დამალვა ',
		create: 'მისალმების შექმნა',
		edit: 'მისალმების რედაქტირება',
		preview: 'მისალმების გადახედვა',
		form: {
			image: {
				label: 'მისალმების ფონი',
			},
			text: {
				label: 'მისალმების ტექსტი ',
				placeholder: 'ჩაწერეთ მისალმება',
			},
		},
	},
	createNews: {
		titleNew: 'სიახლის შექმნა',
		titleEdit: 'სიახლის რედაქტირება',
		preview: 'სიახლის გადახედვა',
		form: {
			title: 'სათაური',
			subTitle: 'ქვესათაური',
			topic: 'სიახლის კატეგორია',
			image: 'გამოსახულება',
			position: 'რიგითი ნომერი',
			body: 'შინაარსი',
			commentable: 'სიახლის კომენტირების შესაძლებლობა',
			refuseReason: 'მიზეზი',
			slug: 'სლაგი',
			url: 'ბმული რესურსზე',
		},
		placeholder: {
			title: 'შეიტანეთ სათაური',
			subTitle: 'შეიტანეთ ქვესათაური',
			titleEn: 'სათაური ადგილობრივ ენაზე',
			text: 'შეიყვანეთ ძირითადი ტექსტი',
			topic: 'შეიყვანეთ კატეგორია',
			refuseReason: 'შეიყვანეთ მიზეზი',
			slug: 'შეიყვანეთ სლაგი',
			url: 'შეიყვანეთ რესურსის ბმული',
		},
		uploadImageTitle: 'ატვირთეთ სიახლის ფონი',
		uploadImageDesc:'დასაშვები ფორმატები: JPEG, PNG. მაქსიმალური ზომა: 8 მბ.<br/>მინიმალური გარჩევადობა: {size}.',
		refuseReason: 'უარყოფის მიზეზი',
	},
	viewNews: {
		isModerate: 'სიახლე გადის მოდერაციას',
		shareNews: 'სიახლის გაზიარება კოლეგებთან ერთად',
		newsSent: 'სიახლე გაიგზავნა',
		statuses: {
			rejected: 'სიახლემ ვერ გაიარა მოდერაცია',
			rejectedDesc: 'თქვენმა სიახლემ მოდერაცია ვერ გაიარა. მიმართეთ ადმინისტრატორს.',
			rejectedSuccess: 'სიახლე უარყოფილია წარმატებით',
			draft: 'სიახლე მონახაზებშია',
			draftDesc: 'თქვენი სიახლე არ გამოქვეყნდა.',
			moderation: 'სიახლე გადის მოდერაციას',
			moderationDesc: 'თქვენი სიახლე მოდერაციის მოლოდინშია. იგი გამოჩნდება პორტალზე თუ ერთ-ერთი მოდერატორი მოიწონებს.',
			published: 'სიახლე გამოქვეყნდა',
			publishedDesc: 'თქვენმა სიახლემ გაიარა მოდერაცია და გამოქვეყნდა პორტალზე.',
			waitModeration: 'მოდერაციის შემდეგ სიახლე გამოქვეყნდება პორტალზე.',
			savedToDrafts: 'სიახლე შენახულია მონახაზებში',
			offModeration: 'მოდერაციის რეჟიმის გამორთვა?',
			offModerationDesc: 'მოდერაციის მოლოდინში მყოფი ყველა სიახლე ავტომატურად გამოქვეყნდება.',
		},
	},
	indexNewsAdmin: {
		name: 'სახელი',
		author: 'ავტორი',
		status: 'სტატუსი',
	},
	indexTopicAdmin: {
		new: 'კატეგორია',
		name: 'სახელი',
		shared: 'ხელმისაწვდომია გამოქვეყნებისთვის',
	},
	indexRegionAdmin: {
		new: 'რეგიონი',
		name: 'სახელი',
		regionExists: 'ასეთი სახელის რეგიონი უკვე არსებობს',
	},
	indexDictionariesAdmin: {
		tripPurposes: 'მოგზაურობის მიზანი',
		currencies: 'ვალუტები',
		transportTypes: 'ტრანსპორტის ტიპები',
		ticketClasses: 'ბილეთების კლასი',
		services: 'სერვისები',
		currencyCode: 'ვალუტები',
		availableForPublish: 'ხელმისაწვდომია გამოსაცემად',
		availableForSelection: 'ხელმისაწვდომია შერჩევისთვის',
	},
	indexSubmittingBudgets: {
		description: 'შეიყვანეთ ბიუჯეტები / ქვებიუჯეტები, გაცვლითი კურსი და დღიური',
		budgets: 'ბიუჯეტები',
		reports: 'ანგარიშები',
		currencyRates: 'გაცვლითი კურსი',
		accommodationLimits: 'განთავსების ლიმიტები',
		dailyAllowance: 'დღიური შემწეობა',
	},
	indexUsersAdmin: {
		name: 'სახელი',
		role: 'როლი',
		roles: 'როლები',
		department: 'დეპარტამენტი',
		alternates: 'მოადგილე',
		alternate: 'მოადგილე',
		subBudgets: 'ქვებიუჯეტის მფლობელები',
		subBudget: 'ქვებიუჯეტის მფლობელი',
		companies: 'კომპანიები',
		previewText: 'მიანიჭეთ აქტიური როლები ძირითადი მომხმარებლების მიერ',
		roleAlreadyExist: 'როლი უკვე დანიშნულია {value}',
		budgetOwnersAlternate: 'ბიუჯეტის მფლობელის მოადგილე',
		budgetOwnersSubBudgetOwner: 'ქვებიუჯეტის მფლობელი ბიუჯეტის მფლობელთან',
	},
	indexHallsAdmin: {
		table: {
			image: 'ფოტო',
			name: 'სახელი',
			type: 'ტიპი',
			numberOfSeats: 'ადგილების რაოდენობა',
			hasProjector: 'პროექტორის ხელმისაწვდომობა;',
		},
		form: {
			image: 'დარბაზის ფოტო ატვირთეთ',
			name: 'სახელი',
			type: 'ტიპი',
			numberOfSeats: 'ადგილების რაოდენობა',
			hasProjector: 'პროექტორის ხელმისაწვდომობა;',
			enter: 'შეიყვანეთ',
		},
		modal: {
			hallReservation: 'დარბაზის დაჯავშნა',
			name: 'სახელი',
			user: 'მომხმარებელი',
			comment: 'კომენტარი',
			commentPlaceholder: 'შეიყვანეთ კომენტარი',
			submitBtn: 'გამოყენება',
			deleteBtn: 'გასუფთავება',
		},
		select: {
			conference_hall: 'საკონფერენციო დარბაზი',
			massage: 'მასაჟი',
			meeting_room: 'შეხვედრების ოთახი',
		}
	},
	indexLogsAdmin: {
		date: 'დრო, თარიღი',
		entity: 'არსი',
		name: 'სახელი',
		action: 'მოქმედება',
		author: 'ავტორი',
		businessTripName: 'სათაური / № აპლიკაციები',
	},
	indexSettingsAdmin: {
		name: 'სახელი',
		status: 'სტატუსი',
	},
	indexBannerAdmin: {
		name: 'სახელი',
		status: 'სტატუსი',
		statuses: {
			active: 'აქტიური',
			notActive: 'არააქტიური',
		},
		new: 'ბანერი',
	},
	indexQuizAdmin: {
		new: 'გამოკითხვა',
		dateAndTime: 'თარიღი, დრო',
		question: 'კითხვა',
		status: 'სტატუსი',
	},
	createQuizAdmin: {
		creating: 'კითხვარის შექმნა',
		editing: 'კითხვარის რედაქტირება',
		form: {
			question: 'კითხვა',
			answer: 'პასუხის ვარიანტი {number}',
			anonymous: 'ანონიმური გამოკითხვა',
		},
		placeholder: {
			question: 'დასვით შეკითხვა',
			answer: 'გაეცით პასუხი',
		},
	},
	vacations: {
		table: {
			id: 'ნომერი',
			createdAt: 'შექმნის თარიღი',
			status: 'სტატუსი',
			user: 'თანამშრომელი',
			manager: 'თავი',
			startDate: 'დაწყების თარიღი',
			endDate: 'დასრულების თარიღი',
		},
		form: {
			user: 'თანამშრომელი',
			manager: 'თავი',
			startDate: 'დაწყების თარიღი',
			endDate: 'დასრულების თარიღი',
			comment: 'კომენტარი',
			enter: 'შეიყვანეთ',
			enterComment: 'შეიყვანეთ კომენტარი',
			submitBtn: 'შექმნა',
			saveBtn: 'შენახვა',
			daysAmount: 'დღეები',
		},
		statuses: {
			approved: 'დამტკიცებულია',
			closed: 'დახურულია',
			processing: 'დამუშავების პროცესშია',
			done: 'დასრულებულია',
			rejected: 'უარყოფილია',
		},
		modal: {
			createdAt: 'შექმნის თარიღი',
			userName: 'თანამშრომლის სრული სახელი',
			managerName: 'მენეჯერის სრული სახელი',
			datesOfVacation: 'შვებულების თარიღი',
			daysAmount: 'დღეების რაოდენობა',
			additional: 'დამატებით',
			submitBtn: 'დამტკიცება',
			submitHrBtn: 'მოწყობა',
			declineBtn: 'უარყოფა',
			declineHrBtn: 'უარყოფა',
		},
		days: {
			vacation: 'წასვლა',
			balance: 'ბალანსი',
			usedDays: 'გატარებული დღეები',
			leftDays: 'დარჩენილი დღეები',
			requiredDays: 'სავალდებულო შვებულების დღეები',
			leftDayEndYear: 'წლის ბოლოს დარჩენილი დღეები',
			noData: 'სამწუხაროდ, მოხდა შეცდომა ან მონაცემები აკლია. გთხოვთ, დაუკავშირდეთ თქვენს ადამიანური რესურსების მენეჯერს.',
		},
		calendar: {
			usedDaysTitle: 'მიმდინარე წელს გამოყენებული შვებულების დღეები',
			plannedTitle: 'დაგეგმილი შვებულების გრაფიკი',
		},
	},
	indexDriversAdmin: {
		photo: 'ავატარი',
		name: 'სახელი გვარი',
		car: 'ავტო',
		carPhoto: 'ავტოს ფოტო',
		carNumber: 'სანომრე ნიშანი',
		phone: 'მძღოლის კონტაქტები',
		form: {
			photo: 'ატვირთეთ მძღოლის ფოტო',
			name: 'მძღოლის სახელი გვარი',
			car: 'ავტო',
			carNumber: 'სანომრე ნიშანი',
			carPhoto: 'ატვირთეთ ავტოს ფოტო',
			type: 'გადაზიდვის ტიპი',
			phone: 'ტელეფონი 1',
			secondPhone: 'ტელეფონი 2',
			smsPhone: 'SMS-ის გასაგზავნი კონტაქტი',
			enter: 'შეიყვანეთ',
			maxSize: 'მაქსიმალური ზომა: {amount}მბ'
		},
		modal: {
			driverBooking: 'მძღოლის დაჯავშნა',
			user: 'მომხმარებელი',
			startDate: 'დაწყების თარიღი',
			endDate: 'დასრულების თარიღი',
			time: 'დრო',
			route: 'მარშრუტი',
      phone: 'ტელეფონის ნომერი',
			type: 'ტიპი',
			comment: 'კომენტარი',
			staff: 'პერსონალი',
			documents: 'დოკუმენტები',
			cargo: 'ტვირთი/წყალი',
			submitBtn: 'დაჯავშნა',
			deleteBtn: 'წაშლა',
		}
	},
	createBannerAdmin: {
		preview: 'ბანერის დათვალიერება',
		titleNew: 'ბანერის შექმნა',
		titleEdit: 'ბანერის რედაქტირება',
		titleCrop: 'ფონის ჩატვირთვა',
		uploadImageTitle: 'ჩატვირთეთ ბანერი ან ბანერის ფონი',
		uploadImageDesc: 'დასაშვები ფორმატები: JPEG, PNG. მაქსიმალური ზომა: 8 МБ. მინიმალური ზომა: 800х100.',
		form: {
			textBanner: 'ბანერის ტექსტი',
			textColor: 'ტექსტის ფერი',
			textColorBanner: 'ბანერის ტექსტის ფერი',
			textBtnColor: 'ღილაკის ტექსტის ფერი',
			btnColor: 'ღილაკის ფერი',
			textBtn: 'ღილაკის ტექსტი',
			link: 'ღილაკის ბმული',
			startDate: 'პუბლიკაციის გამოქვეყნების თარიღი',
			timeStart: 'დრო',
			endDate: 'პუბლიკაციის გამოქვეყნების დასრულების თარიღი',
			timeEnd: 'დრო',
		},
		placeholder: {
			textBanner: 'ბანერის ძირითადი ტექსტი',
			textBtn: 'ღილაკის ტექსტი',
			link: 'ჩასვით ბმული',
			startDate: 'დაწყების თარიღი',
			timeStart: 'დაწყების დრო',
			endDate: 'დასასრულის თარიღი',
			timeEnd: 'დასრულების დრო',
		},
		danger: {
			startDate: 'გამოქვეყნების თარიღი',
			endDate: 'პუბლიკაციის გამოქვეყნების დასრულების თარიღი',
		},
		activeMessage: 'აქტიური შეიძლება იყოს მხოლოდ ერთი ბანერი',
	},
	createTopicAdmin: {
		creating: 'კატეგორიის შექმნა',
		editing: 'კატეგორიის რედაქტირება',
		form: {
			name: 'კატეგორიის სახელწოდება',
			shared: 'ხელმისაწვდომია გამოქვეყნებისთვის',
		},
		placeholder: {
			name: 'ჩაწერეთ კატეგორიის სახელწოდება',
		},
	},
	createRegionAdmin: {
		creating: 'რეგიონის შექმნა',
		editing: 'რეგიონის რედაქტირება',
		form: {
			name: 'რეგიონის სახელწოდება',
			rawCountries: 'ქვეყნები',
		},
		placeholder: {
			name: 'შეიტანეთ რეგიონის სახელი',
		},
	},
	editPageAdmin: {
		title: 'გვერდის რედაქტირება',
		infoIcon: 'ატვირთეთ პიქტოგრამა გვერდისთვის',
		showInMenu: 'მენიუში ჩვენება',
		resourceIcon: 'ჩამოტვირთეთ ხატულა რესურსისთვის',
		subtitle: 'ქვესათაური ლოკალურ ენაზე',
		subtitleEn: 'ქვესათაური ინგლისურ ენაზე',
		localTitle: 'სათაური ლოკალურ ენაზე',
		englishTitle: 'სათაური ინგლისურ ენაზე',
	},
	createDictionariesAdmin: {
		title: {
			trip_purpose: 'შექმენით მოგზაურობის მიზანი',
			currencies: 'ვალუტის შექმნა',
			transport: 'შექმენით ტრანსპორტის ტიპი',
			ticket: 'ბილეთების კლასის შექმნა',
			service: 'სერვისის შექმნა',
		},
		label: {
			trip_purpose: 'მოგზაურობის მიზანი',
			currencies: 'ვალუტა',
			transport: 'ტრანსპორტის ტიპი',
			ticket: 'ბილეთების კლასი',
			service: 'სერვისი',
		},
		placeholder: 'შეიყვანეთ სათაური',
		child: {
			transport: 'ბილეთების კლასი',
		},
	},
	editDictionariesAdmin: {
		title: {
			trip_purpose: 'მოგზაურობის დანიშნულების ადგილის რედაქტირება',
			currencies: 'ვალუტის რედაქტირება',
			transport: 'ტრანსპორტის ტიპის რედაქტირება',
			ticket: 'ბილეთების კლასის რედაქტირება',
			service: 'სერვისის რედაქტირება',
		},
	},
	createBudgetAdmin: {
		title: 'შექმენით ბიუჯეტი',
		subBudgetTitle: 'შექმენით ქვებიუჯეტი',
		budget: 'ბიუჯეტი',
		subBudget: 'ქვებიუჯეტი',
		budgetOwner: 'ბიუჯეტის მფლობელი',
		subBudgetOwner: 'ქვებიუჯეტის მფლობელი',
		budgetSubbudgetName: 'ბიუჯეტი / ქვებიუჯეტის სახელი',
		budgetName: 'ბიუჯეტი სახელი',
		subBudgetName: 'ქვებიუჯეტის სახელი',
		defaultBudget: 'ნაგულისხმევი ბიუჯეტი',
		defaultSubBudget: 'ნაგულისხმევი ქვებიუჯეტი',
		placeholder: {
			user: 'აირჩიეთ ბიუჯეტის მფლობელი',
			subBudgetOwner: 'აირჩიეთ ქვებიუჯეტის მფლობელი',
			name: 'შეიყვანეთ ბიუჯეტის სახელი',
			subName: 'შეიყვანეთ ქვებიუჯეტის დასახელება',
			year: 'აირჩიეთ წელი',
		},
		createBudget: 'შექმენით ბიუჯეტი',
		createSubBudget: 'შექმენით ქვებიუჯეტი',
		empty: 'ბიუჯეტი ჯერ არ შექმნილა',
		emptyByParams: 'მითითებულ პარამეტრებზე შედეგი ვერ მოიძებნა.',
	},
	editBudgetAdmin: {
		title: 'ბიუჯეტის რედაქტირება',
		subBudgetTitle: 'ქვებიუჯეტის რედაქტირება',
	},
	createCurrencyRate: {
		currencyRate: 'გაცვლითი კურსი',
		addRate: 'კურსის დამატება',
		placeholders: {
			date: 'აირჩიეთ თარიღი',
		},
		empty: 'ვალუტის კურსი ჯერ არ არის შექმნილი',
	},
	editDailyAllowance: {
		dailyAllowance: 'დღიური შემწეობა',
		dailyAllowanceSize: 'დღიური შემწეობა',
		travelDirection: 'მოგზაურობის მიმართულება',
		travelDirectionPlaceholder: 'შეიყვანეთ მოგზაურობის მიმართულება',
		create: 'შექმენით დღიური',
		creating: 'შექმენით დღიური',
    editing: 'დღიურის რედაქტირება',
	},
	createAccLimit: {
		create: 'დაამატეთ განთავსების ლიმიტი',
		dailyAllowance: 'მოგზაურობის მიმართულება',
		placeholder: {
			dailyAllowance: 'აირჩიეთ მოგზაურობის მიმართულება',
		},
		editing: 'განთავსების ლიმიტის რედაქტირება',
		creating: 'განთავსების ლიმიტის შექმნა',
		amount: 'განთავსების ლიმიტი',
		year: 'წელი',
	},
	budgetReport: {
		total: 'სულ',
		used: 'Გამოყენებული',
		remaining: 'დარჩენილი',
		owners: 'ბიუჯეტი / ქვებიუჯეტის მფლობელი',
		budget: 'ბიუჯეტი',
		sub_budget: 'ქვებიუჯეტი',
		balance: 'ბალანსი',
		noBudgets: 'ბიუჯეტი ჯერ არ შექმნილა',
		allDepartments: 'ყველა დეპარტამენტი',
		corporate: 'კორპორატიული',
		finance: 'ფინანსები',
		spent: 'გაატარა',
		amountPending: 'მომლოდინე თანხა.',
	},
	businessTrips: {
		faq: 'ფუნქციური სახელმძღვანელო {link}',
		faqText: '«Ბიზნეს მოგზაურობა»',
		comments: 'კომენტარები',
		transfer: 'Გადაცემა',
		route: 'მარშრუტი',
		created: 'Შექმნილია მიერ',
		title: 'Ბიზნეს მოგზაურობა',
		allTrips: 'ყველა აპლიკაცია',
		daysCount: 'Დღეების რაოდენობა',
		myTrips: 'ჩემი აპლიკაციები',
		trip: 'განაცხადი',
		trips: 'აპლიკაციები',
		approved: 'დამტკიცებულია',
		inProcessing: 'Პროცესში',
		completed: 'დასრულებული',
		budgets: 'ბიუჯეტები',
		reportsByEmployee: 'დაკავშირებული ანგარიში თანამშრომლებზე',
		number: 'ნომერი',
		status: 'სტატუსი',
		employeeOrNot: 'თანამშრომელი / კონსულტანტი',
		responsible: 'შემსრულებელი',
		takeOnWork: 'მუშაობაში ჩართვა',
		tripPurpose: 'მოგზაურობის მიზანი',
		destination: 'დანიშნულება',
		startDateToEndDate: 'დაწყების / დასრულების თარიღი',
		plan: 'Გეგმა',
		fact: 'ფაქტი',
		planSum: 'თანხის ({currencySymbol}) გეგმა',
		factSum: 'თანხის ({currencySymbol}) ფაქტი',
		filters: {
			startDate: 'Დაწყების თარიღი',
			endDate: 'ვადის გასვლის თარიღი',
			createdDate: 'შექმნის თარიღი',
			noResponsible: 'პასუხისმგებელი არ არის',
		},
		deleteReason: 'წაშლის მიზეზი',
		cancelReason: 'გაუქმების მიზეზი',
		cancelSum: 'გაუქმების თანხა',
		submitCancel: 'გაუქმების დადასტურება',
		submitCancelBtn: 'გაუქმება',
		roleStatuses: {
			approved: 'განაცხადი დამტკიცებულია',
			pending: 'განაცხადი დამტკიცებისთვის',
			rejected: 'განაცხადი უარყოფილია',
		},
		factSpent: 'რეალური ხარჯები',
		pinnedEmployees: 'დანიშნული თანამშრომლები',
		viewFrom: 'თქვენ ათვალიერებთ გვერდს საიდან',
		fromAllBudgetOwners: 'ყველა ბიუჯეტის მფლობელი',
		inputAccountantExpensesReason: 'შეიყვანეთ რეალური ხარჯების გადაჭარბების მიზეზი',
		noteModal: {
			title: 'საქმიანი მოგზაურობის რეგისტრაციის წესები',
      more: 'მეტი ინფორმაცია მივლინების შესახებ',
      isAcquainted: 'გავეცანი',
			fields: {
				rule: 'წესი',
				shortDescription: 'მოკლე აღწერა',
				sources: 'რესურსები',
			},
			items: {
				bookingAgent: {
					rule: 'ვის მეშვეობით ვაკეთებთ დაჯავშნას?',
					shortDescription: '<span class="font-weight-boldest">სააგენტოს</span> მეშვეობით, არა Booking/OLX/Instagram/Airbnb !!!'
				},
				applicationDeadline: {
					rule: 'განაცხადის ვადა',
					shortDescription: '<div><span class="font-weight-boldest">უკრაინა</span> — ≥5 დღე</div><div><span class="font-weight-boldest">საზღვარგარეთ</span> — ≥ 7 დღე</div><div>*მოკლე ვადაში განაცხადის წარდგენა არ იძლევა გარანტიას ბილეთების/სასტუმროების ხელმისაწვდომობის</div><div class="font-weight-boldest">*საქმიანი მოგზაურობის განაცხადის იმავე დღეს წარდგენა მკაცრად აკრძალულია!</div>'
				},
				approval: {
					rule: 'დამტკიცება',
					shortDescription: '<ul><li>განაცხადის წარდგენის შემდეგ, ოფის მენეჯერები ავსებენ სავარაუდო თანხებს და აგზავნიან განაცხადს დასამტკიცებლად ბიუჯეტის მფლობელთან (<span class="font-weight-boldest">ყურადღება:</span> ბიუჯეტის მფლობელი ყოველთვის არ არის უშუალო ხელმძღვანელი)</li><li>ყველა საზღვარგარეთ მივლინება უნდა დამტკიცდეს გენერალური დირექტორის მიერ (ელ. ფოსტის მეშვეობით) პორტალზე განაცხადის შექმნამდე</li></ul>'
				},
				accommodationLimits: {
					rule: 'განთავსების ლიმიტები',
					shortDescription: '<div class="font-weight-boldest">უკრაინა:</div><ul><li>დიდი ქალაქები — <span class="font-weight-boldest">2 200 გრივნამდე/დღეში;</span></li><li>პატარა ქალაქები — <span class="font-weight-boldest">1 800 გრივნამდე/დღეში.</span></li></ul><div>*სისტემაში დაყენებულია ლიმიტები საშუალო მნიშვნელობით - 2000 გრივნა/დღეში</div><div class="font-weight-boldest">საზღვარგარეთ:</div><ul><li>შვეიცარია, აშშ, დიდი ბრიტანეთი - 300 €</li><li>სხვები - 200 €</li></ul>'
				},
				overLimit: {
					rule: 'ლიმიტის გადაჭარბება',
					shortDescription: 'ლიმიტის გადაჭარბების პასუხისმგებლობა ეკისრება ბიუჯეტის მფლობელს'
				},
				dailyAllowance: {
					rule: 'დღიური შემწეობა',
					shortDescription: '<ul><li><span class="font-weight-boldest">უკრაინა</span> — 500 გრივნა</li><li><span class="font-weight-boldest">საზღვარგარეთ</span> — 50 €</li></ul>'
				},
				notReimbursed: {
					rule: 'არ ანაზღაურდება',
					shortDescription: 'მინი-ბარი, ალკოჰოლი, თამბაქო, ჩაის ფული და სხვა'
				},
				duration: {
					rule: 'ხანგრძლივობა',
					shortDescription: '<ul><li><span class="font-weight-boldest">უკრაინა</span> — 30 დღემდე</li><li><span class="font-weight-boldest">საზღვარგარეთ</span> — 60 დღემდე</li></ul>'
				},
				transport: {
					rule: 'ტრანსპორტი',
					shortDescription: '<span class="font-weight-boldest">მძღოლები</span> დამოუკიდებლად ჯავშნდებიან Outlook-ის მეშვეობით <span class="font-weight-boldest">კორპორატიული ტაქსი</span> მოთხოვნით ელ. ფოსტაზე: <a href="mailto:office12@morshynska.ua">office12@morshynska.ua</a>',
					sources: '<a href="https://myids.morshynska.ua/login?path=%2Fpages%2Fbookingdrivers" target="_blank">ბმული</a>'
				},
				expenseCompensation: {
					rule: 'ხარჯების ანაზღაურება',
					shortDescription: 'დამოუკიდებელი ხარჯები ანაზღაურდება მხოლოდ დამადასტურებელი დოკუმენტების ბუღალტერიაში წარდგენის შემთხვევაში (ქვითრები, აქტები, ინვოისები)'
				},
				importantDocuments: {
					rule: 'მნიშვნელოვანი დოკუმენტები საქმიანი მოგზაურობისთვის',
					shortDescription: 'საქმიანი მოგზაურობის მოწმობა და ბრძანებიდან ამონაწერი გაიცემა ოფის მენეჯერის მიერ და ერთვის განაცხადს.'
				},
				otherDocuments: {
					rule: 'სხვა დოკუმენტები',
					shortDescription: 'ყველა სხვა დოკუმენტს: ბილეთები, სასტუმროს ვაუჩერი და ა.შ., ოფის მენეჯერები ურთებენ პორტალზე განაცხადს'
				},
				otherImportantDocuments: {
					rule: 'სხვა მნიშვნელოვანი დოკუმენტები',
					shortDescription: '<ul class="business-note-table_list-number"><li>აუცილებლად მიუთითეთ ყველა საჭირო ინფორმაცია საქმიანი მოგზაურობის ორგანიზებისთვის (პარკინგი, სასურველი ლოკაცია და ა.შ.)</li><li>საზღვარგარეთ მივლინებისთვის გაითვალისწინეთ დამატებითი დოკუმენტების ქონის აუცილებლობა სამხედრო ვალდებულთათვის:</li></ul><ul><li>ბრძანება საქმიანი მოგზაურობის შესახებ საწარმოს ხელმძღვანელის ხელმოწერითა და ბეჭდით (არსებობის შემთხვევაში);</li><li>საქმიანი მოგზაურობის მოწმობა;</li><li>ცნობა სამხედრო ვალდებული თანამშრომლის დაჯავშნის შესახებ საწარმოში (პასუხისმგებელი პირის / HR ხელმოწერით);</li><li>უკრაინის მოქალაქის პასპორტი საზღვარგარეთ გასასვლელად;</li><li>სამხედრო აღრიცხვის დოკუმენტი (სამხედრო ბილეთი ან სამხედრო ვალდებულის დროებითი მოწმობა);</li><li>აპლიკაცია «Резерв+» აქტუალური მონაცემებით;</li><li>მიმღები მხარის მოწვევა, კონფერენციის ბილეთი ან სხვა დოკუმენტები, რომლებიც ადასტურებენ საზღვარგარეთ გასვლის მიზანს;</li><li>ტურისტული დაზღვევის პოლისი მივლინების პერიოდისთვის;</li><li>სხვა დოკუმენტები, რომლებიც ადასტურებენ საზღვარგარეთ გასვლის საფუძვლებს უკრაინის მოქმედი კანონმდებლობის მოთხოვნების შესაბამისად (საჭიროების შემთხვევაში).</li></ul><div class="font-weight-boldest">კომპანიის შესაბამისი განყოფილებებიდან დოკუმენტების მიღებასა და საზღვრის გადაკვეთისას მათ ქონაზე პასუხისმგებელია თანამშრომელი!</div><ol start="3" style="padding-inline-start: 20px"><li>საზღვარგარეთ მივლინებისთვის შეამოწმეთ კონკრეტული ქვეყნის საზღვრის გადაკვეთის აქტუალური წესები (დაზღვევის პოლისის, სასტუმროს ვაუჩერის, ნაღდი ფულის ხელმისაწვდომობა (და ვალუტის დეკლარაციის გარეშე გადატანის შეზღუდვები - 10 000 $), თამბაქოს პროდუქტების გადატანის შეზღუდვები (არაუმეტეს 2 ღილაკი) და ალკოჰოლი, ხორცის, რძის პროდუქტების, ხილის და ა.შ. გადატანის აკრძალვა (თუნდაც სენდვიჩები/იოგურტი გზაში საკუთარ საჭმელად)</li></ol>'
				},
				reporting: {
					rule: 'საქმიანი მოგზაურობის შესახებ ანგარიშგება',
					shortDescription: '- შევსებული საქმიანი მოგზაურობის მოწმობა გასვლისა და ჩამოსვლის ნიშნებით, თანამშრომელმა უნდა გადასცეს ბუღალტერიას დასრულებიდან 7 სამუშაო დღის განმავლობაში + დაამატოს სხვა დოკუმენტები, თუ ისინი საჭიროა (ქვითრები დამატებითი ხარჯების შესახებ და ა.შ.)<div class="font-weight-boldest">დოკუმენტების ხელმისაწვდომობასა და წარდგენაზე პასუხისმგებელია თანამშრომელი!</div>'
				}
			}
		}
	},
	createBusinessTrip: {
		title: 'შექმენით საქმიანი მოგზაურობა',
		createTrip: 'შექმენით საქმიანი მოგზაურობა',
		employee: 'თანამშრომელი',
		notEmployee: 'კონსულტანტი',
		fio: 'გვარი და სახელი',
		enter: 'შეიყვანეთ',
		choose: 'არჩევა',
		startBusinessTrip: 'საქმიანი მოგზაურობის დაწყება',
		endBusinessTrip: 'მივლინების დასასრული',
		periodBusinessTrip: 'საქმიანი მოგზაურობის პერიოდი',
		dayCounts: 'Დღეების რაოდენობა: {count}',
		additional: 'დამატებით',
		transferAirport: 'ტრანსფერი აეროპორტიდან / აეროპორტამდე',
		transferOffice: 'ტრანსფერი ოფისში ან სხვა პუნქტში',
		datePlaceTime: 'თარიღი, ადგილი და დრო',
		transportType: 'ტრანსპორტის ტიპი',
		transport: 'მოგზაურობა',
		chooseDate: 'აირჩიეთ თარიღი',
		cityAndCountry: 'დანიშნულება',
		departurePoint: 'გამგზავრების წერტილი',
		nameOfCompany: 'Კომპანიის სახელი',
		nameOfCompanyModal: 'Კომპანიის სახელი',
		residence: 'რეზიდენცია',
		residencePeriod: 'რეზიდენტობის პერიოდი',
		country: 'ქვეყანა',
		city: 'ქალაქი',
		placeholder: {
			fio: 'შეიყვანეთ სახელი და გვარი',
			nameOfCompany: 'შეიყვანეთ კომპანიის სახელი',
			user: 'აირჩიეთ თანამშრომელი',
			transportType: 'აირჩიეთ ტრანსპორტის ტიპი',
			ticketType: 'აირჩიეთ ბილეთის კლასი',
			additional: 'აირჩიეთ დამატებითი სერვისები',
			transferAirport: 'მიუთითეთ თარიღი, ადგილი და დრო',
			otherInfo: 'მოგზაურობის სურვილები',
			choose: 'აირჩიეთ',
		},
		errors: {
			cantCreateTrip: 'მივლინების შექმნა შეუძლებელია',
			notFoundRoleAndBudgetCount: 'არცერთი ბიზნეს ერთეული არ არის მინიჭებული თქვენს ბიზნესზე {roles} და ბიუჯეტი არ იყო გამოყოფილი. გთხოვთ, დაუკავშირდეთ თქვენს ხელმძღვანელს.',
			not_found_role: 'არცერთი ბიზნეს ერთეული არ არის მინიჭებული თქვენს ბიზნესზე {roles}. გთხოვთ, დაუკავშირდეთ თქვენს ხელმძღვანელს.',
			budget_count: 'ბიუჯეტი არ არის გამოყოფილი თქვენი ბიზნეს ერთეულისთვის. გთხოვთ, დაუკავშირდეთ თქვენს ხელმძღვანელს.',
		},
		empty: 'ჯერ არ გქონიათ მივლინებები',
		emptyDesc: 'შექმენით მივლინების მოთხოვნა',
		arrange: 'გადახდა',
		successGoToApprove: 'განაცხადის ნომერი {number} გაიგზავნა დასამუშავებლად.',
		successGoToApproveNoNumber: 'განაცხადის ნომერი გაიგზავნა დასამუშავებლად.',
		successGoToReApprove: 'განაცხადის ნომერი  {number} გაიგზავნა ხელახლა დასამტკიცებლად.',
		successClosed: 'განაცხადის ნომერი {number} დახურულია.'
	},
	editBusinessTrip: {
		title: 'მოგზაურობის რედაქტირება',
		request: 'განაცხადი {number}',
		budgetOwnerForApprove: 'ბიუჯეტი / ქვებიუჯეტის მფლობელი',
		budget: 'ბიუჯეტი / ქვებიუჯეტის მფლობელი',
		hotelPrice: 'ცხოვრების ღირებულება',
		transportPrice: 'ტრანსპორტირების ღირებულება',
		transferPrice: 'გადარიცხვის ღირებულება',
		dailyPayment: 'დღიური შემწეობა',
		otherExpenses: 'სხვა',
		otherExpensesDestination: 'თანხის მინიჭება "სხვა"',
		modalCancelSuccess: 'მოთხოვნა გაიგზავნა',
		modalCancelSuccessText: 'მოთხოვნა გაიგზავნა ადმინისტრაციულ მენეჯერთან. დაელოდეთ შეტყობინებას ელექტრონულ ფოსტაზე გაუქმების შესახებ.',
		total: 'სულ',
		placeholder: {
			budgetOwnerForApprove: 'აირჩიეთ სიიდან',
			budget: 'აირჩიეთ სიიდან',
		},
		reApproval: 'ხელახალი დამტკიცება',
		reApprovalDesc: 'გსურთ ხელახალი დამტკიცების განაცხადის გაგზავნა?',
		wishes: 'სურვილები',
		accommodation: 'განთავსება',
		transport: 'ტრანსპორტი',
		transfer: 'ადაცემა',
		budgetBalance: 'ბიუჯეტის ნაშთი',
		uploadDocumentsTickets: 'ატვირთეთ დოკუმენტები, ბილეთები',
		hotelPriceLimitExceeds: 'აჭარბებს ლიმიტს {difference} {currency}-ით',
		hotelPriceLimitWithin: 'განთავსების ლიმიტში {limit} {currency} შედის ({difference} {currency} ნორმის ფარგლებში)'
	},
	businessTripStatuses: {
		created: 'Პროცესში',
		wait_approval: 'Დამტკიცების მოლოდინში',
		approved: 'დამტკიცებულია',
		partially_approved: 'ნაწილობრივ დამტკიცებულია',
		completed: 'ჩარჩოში ჩასმული',
		closed: 'დახურულია',
		processing: 'სამსახურში შეიყვანეს',
		decline: 'უარყოფილია',
		cancel_request: 'გაუქმების მოთხოვნა',
		canceled: 'გაუქმებულია',
	},
	profile: {
		information: 'ინფორმაცია',
		articlesMy: 'ჩემი პუბლიკაციები',
		articles: 'პუბლიკაციები',
		birthday: 'დაბადების დღე',
		birthdaysModal: 'დაბადების დღეები',
		country: 'ქვეყანა',
		city: 'ქალაქი',
		businessUnit: 'ბიზნეს-ერთეული',
		company: 'კომპანია',
		socialProfiles: 'სოციალური პროფილი',
		contactInfo: 'საკონტაქტო ინფორმაცია',
		phone: 'ტელეფონი',
		mail: 'ლექტრონული მისამართი',
		workAddress: 'სამუშაო ადგილის მისამართი',
		career: 'კარიერა',
		joinedToTeam: 'შეუერთდა IDS UKRAINE გუნდს',
		leader: 'ხელმძღვანელი',
		personalInfo: 'პირადი ინფორმაცია',
		language: 'ენების ფლობა',
		certificationsAndSkills: 'სერტიფიკატები და დამატებით უნარები',
		workExperience: 'სამუშაო გამოცდილება IDS UKRAINE-მდე',
		hobbies: 'გატაცება',
		functional: 'ფუნქციონალი',
		removedText: 'ამ მომენტში ეს თანამშრომელი კომპანიაში არ მუშაობს',
	},
	profileSettings: {
		title: 'პროფილის პარამეტრები',
		mainInformation: 'ძირითადი ინფორმაცია',
		socialProfiles: 'სოციალური პროფილი',
		alerts: 'შეტყობინება',
		upload: 'ფოტოს ატვირთვა',
		receiveAlerts: 'შეტყობინების მიღება ელექტრონულ ფოსტაზე',
		form: {
			avatar: 'ფოტო',
			workAddress: 'სამუშაო ადგილის მისამართი',
			languages: 'ენების ფლობა',
			additionalSkills: 'სერტიფიკატები და დამატებითი უნარები',
			prevExperience: 'სამუშაო გამოცდილება IDS UKRAINE-მდე',
			hobbies: 'გატაცება',
			social: 'სოც. ქსეელი',
			link: 'ბმული',
			functional: 'ფუნქციონალი',
			locale: 'პორტალის ენა',
			receivePublicationMessage: 'პასუხი ჩემს პუბლიკაციებზე',
			receiveBirthdayMessage: 'დაბადების დღის მილოცვა',
		},
		placeholder: {
			workAddress: 'მიუთითეთ მისამართი',
			languages: 'ენები',
			additionalSkills: 'მითითებები სერტიფიკატებსა და უნარებზე',
			prevExperience: 'სამუშაო გამოცდილება',
			hobbies: 'მიუთითეთ თქვენი გატაცებები',
			social: 'აირჩიეთ სოც. ქსელი',
			link: 'ჩასვით ბმული',
			functional: 'აღწერეთ თქვენი მოვალეობები',
		},
	},
	staffSearch: {
		name: 'სახელი',
		phone: 'ტელეფონი',
		email: 'ელ. ფოსტა',
	},
	search: {
		title: 'ძებნის შედეგი',
		desc: 'საძებნ სიტყვაზე <span class="font-weight-bold">{search}</span> მოიძებნა <span class="font-weight-bold">{count}</span> შედეგი',
		articles: 'სიახლეები',
		staff: 'თანამშრომლები',
		medias: 'დოკუმენტები',
		events: 'ღონისძიებები',
		empty: {
			title: 'ძებნა უშედეგოა',
			desc: 'სცადეთ სხვა საკვანძო სიტყვა',
		},
	},
	auth: {
		auth: 'ავტორიზაცია',
		authDesc: 'გამოიყენეთ თქვენი კორპორატიული რწმუნებათა სიგელები შესასვლელად',
		authConfirm: 'შეამოწმეთ ელ. ფოსტა',
		authConfirmDesc: 'ახლახან გამოგიგზავნეთ ექვსნიშნა კოდი მისამართზე <span class="font-weight-boldest">{email}</span>. არ დახუროთ ეს ფანჯარა, შეამოწმეთ ელ. ფოსტა და შეიტანეთ კოდი.',
		form: {
			email: 'ლექტრონული მისამართი',
			password: 'პაროლი',
			code: 'კოდი',
		},
		iAccept: 'ვეთანხმები',
		termsOfUseOfThePortal: 'პორტალის გამოყენების წესები',
		signIn: 'შესვლა',
		or: 'ან',
		orExternal: 'ან (მხოლოდ გარე მომხმარებლებისთვის)',
		signInMicrosoft: 'შედით microsoft-ით',
		didtReceiveLetter: 'წერილი არ მოვიდა?',
		sendCodeAgain: 'ახალი კოდის მოთხოვნა',
		codeSent: 'თქვენი კოდი გამოიგზავნა განმეორებით.',
		error: {
			invalidCredentials: 'ლოგინი ან პაროლი არასწორია',
			blockAccount: 'თქვენი ანგარიში დაბლოკილია. აღსადგენად მიმართეთ ადმინს',
			accountUnlock: 'ბლოკი მოხსნილია',
			invalidCode: 'კოდი არასწორია. სცადეთ ხელახლა.',
		},
	},
	validation: {
		invalid: '{name} მიუწვდომელია',
		required: '{name} სავალდებულო ველი',
		requiredIf: '{name} სავალდებულო ველი',
		greaterThan: 'მეტი უნდა იყოს {value}',
		lessThan: 'მაქსიმალური {value}',
		decimal: 'უბრალოდ ნომერი',
		requiredDays: 'აირჩიეთ დღეები განმეორების დასაყენებლად',
		alphaNum: '{name} ივსება ინგლისურ ენაზე, სიტყვათშორისი სივრცის გარეშე',
		alphaNumCustom: '{name} ივსება ინგლისურ ენაზე, სიტყვათშორისი სივრცის გარეშე',
		variant: 'სავალდებულო ველი',
		url: '{name} უნდა იყოს url მისამართი',
		imageFormat: 'ფაილის არასწორი ფორმატი. დასაშვები ფორმატი: {format}',
		imageWeight: 'ფაილი ძალიან დიდია. მაქსიმალური ზომა: {weight} MB',
		imageSize: 'ფაილის არასწორი ზომა. მინიმალური ზომა: {size}',
		imageMaxCount: 'ასატვირთი ფაილების მაქსიმალური რაოდენობა - {count}',
		fileNameMaxCount: 'ფაილის სახელის სიმბოლოების მაქსიმალური რაოდენობაა {count}',
		fileMinWeight: 'ფაილის მინიმალური ზომა: {size} კბ',
		someFileAlreadyExists: 'სისტემაში უკვე არსებობს ერთ-ერთი ფაილი',
		isAfter: '{name} დაწყების თარიღის შემდეგ',
		minLength: 'სიმბოლოების მინიმალური რაოდენობაა {count}',
		maxLength: 'სიმბოლოების მაქსიმალური რაოდენობაა {count}',
		maxValue: 'მაქსიმალური ღირებულება - {count}',
		minValue: 'მინიმალური მნიშვნელობა - {count}',
		fileType: 'ატვირთული ფაილის ფორმატი დაუშვებელია',
		containsUppercase: 'პაროლი უნდა შეიცავდეს დიდ ასოს',
		containsLowercase: 'პაროლი უნდა შეიცავდეს პატარა ასოს',
		containsNumber: 'პაროლი უნდა შეიცავდეს რიცხვს',
		containsSpecial: 'პაროლი უნდა შეიცავდეს სპეციალურ სიმბოლოს (#?!@%^&*-)',
		email: 'ელფოსტის არასწორი ფორმატი',
		emailExists: 'ეს ელ. ფოსტა უკვე რეგისტრირებულია სისტემაში',
	},
	quiz: {
		quiz: 'კითხვარი',
		startQuiz: 'გამოკითხვა',
		selected: 'პასუხი არჩეულია',
		results: 'გამოკითხვის შედეგები',
		variant: 'ერთ-ერთი ვარიანტი',
		publicResults: 'შედეგები',
		voting: 'ხმის მიცემა',
		activeMessage: 'აქტიური შეიძლება იყოს მხოლოდ ერთი კითხვარი',
		thankYou: 'მადლობა გამოკითხვაში მონაწილეობისთვის',
		statuses: {
			active: 'აქტიური',
			notActive: 'არააქტიური',
		},
		peopleVote: 'ხმა მისცა 0 ადამიანმა | ხმა მისცა {n} ადამიანმა | ხმა მისცა {n} ადამიანმა | ხმა მისცა {n} ადამიანმა ',
		peopleSelected: 'არჩეულია 0 ადამიანი | არჩეულია  {n} ადამიანი | არჩეულია  {n} ადამიანი | არჩეულია  {n} ადამიანი ',
	},
	calendar: {
		birthdayDisabledText: 'ამ მომხმარებელს აქვს შეზღუდვები მისალმების გაგზავნაზე',
		toEvents: 'ღონისძიებები',
		eventText: 'ღონისძიებები',
		createEvent: 'ღონისძიების შექმნა',
		editEvent: 'ღონისძიების რედაქტირება',
		removeEvent: 'წაშლის დადასტურება',
		removeEventAlert: 'ღონისძიება წაშლილია',
		birthdays: 'დაბადების თარიღი',
		units: 'ბიზნეს-ერთეული',
		year: 'წელი',
		month: 'თვე',
		week: 'კვირა',
		day: 'დღე',
		today: 'დღეს',
		none: 'არ მეორდება',
		typeEvent: 'ღონისძიება',
		typeInfo: 'საინფორმაციო',
		showAllUsers: 'ყველა მონაწილის ჩვენება',
		participating: 'მონაწილეობთ?',
		wantToJoin: 'გსურთ მონაწილეობის მიღება?',
		successJoinMessage: 'მოთხოვნა მონაწილეობაზე გაეგზავნა ორგანიზატორს',
		allParticipants: 'ყველა მონაწილე',
		participant: '0 მონაწილე| {n} მონაწილე| არჩეულია {n} მონაწილე| არჩეულია {n} მონაწილე',
		// birthdayMan: '0 იუბილარი | {n} იუბილარი | არჩეულია {n} იუბილარი | Выбрал {n} იუბილარი',
		birthdayMan: '0 იუბილარი | {n} იუბილარი | {n} იუბილარი | {n} იუბილარი',
		inputCongratulation: 'შეიტანეთ მილოცვა',
		repeatAt: 'გამეორება',
		onSuchDays: 'ასეთ დღეებში:',
		congratulationWasSend: 'მილოცვა გაგზავნილია!',
		birthdaySaved: 'დაბადების დღე შენახულია!',
		addToCalendar: 'დაამატეთ Outlook კალენდარში',
		event: {
			title: {
				label: 'ღონისძიების სახელწოდება',
				placeholder: 'ღონისძიების სახელწოდება',
			},
			startDate: {
				label: 'ღონისძიების დაწყების თარიღი',
			},
			endDate: {
				label: 'ღონისძიების დასრულების თარიღი',
			},
			periodicity: {
				label: 'პერიოდულობა',
			},
			type: {
				label: 'ღონისძიების ტიპი',
			},
			link: {
				label: 'ღონისძიების ბმული',
			},
			users: {
				label: 'მონაწილეები',
			},
			invited: {
				label: 'მოწვეულები',
			},
			description: {
				label: 'აღწერა',
				placeholder: 'ღონისძიების აღწერა',
			},
		},
		days: {
			monday: 'ორშ',
			tuesday: 'სამშ',
			wednesday: 'ოთხ',
			thursday: 'ხუთ',
			friday: 'პარ',
			saturday: 'შაბ',
			sunday: 'კვ',
		},
		finish: 'დასრულება',
		repeatSettings: 'გამეორების პარამეტრები',
		organizer: 'ორგანიზატორი',
	},
	ie: {
		header: 'სამწუხაროდ თქვენი ბრაუზერი შეუსაბამოა',
		text: 'IDS Ukraine ინტერნეტ-პორტალზე შესასვლელად გამოიყენეთ სხვა ბრაუზერი.',
	},
	knowledgeBase: {
		folderBase: 'საქაღალდე',
		fileBase: 'ფაილი',
		createFolder: 'საქაღალდის შექმნა',
		editFolder: 'საქაღალდის რედაქტირება',
		toCreateFolder: 'საქაღალდის შექმნა',
		toEditFolder: 'საქაღალდის რედაქტირება',
		title: 'სათაური',
		author: 'ავტორი',
		createdAt: 'შექმნის თარიღი',
		size: 'ზომა',
		folder: {
			name: {
				label: 'საქაღალდის სახელი',
				placeholder: 'შეიტანეთ საქაღალდის სახელი',
			},
			description: {
				label: 'აღწერა',
				placeholder: 'შეიტანეთ საქაღალდის აღწერა',
			},
			author: 'ავტორი',
			createdAt: 'შექმნის თარიღი',
			size: 'ზომა',
		},
		emptyRootTitle: 'გვერდი "დოკუმენტები" ცარიელია',
		emptyRootDescription: 'საქაღალდის შექმნა',
		emptyTitle: 'ეს საქაღალდე ცარიელია',
		emptyDescription: 'ასატვირთად გადმოათრიეთ საქაღალდე ამ ფანჯარაში.',
		uploadIcon: 'ატვირთეთ პიქტოგრამა საქაღალდისთვის',
	},
	bookmarks: {
		myLinks: 'ჩემი ბმულები',
		addLink: 'ბმულის დამატება',
		editLink: 'ბმულის რედაქტირება',
		toAddLink: 'ბმულის დამატება',
		link: {
			title: {
				label: 'ბმულის სახელი',
				placeholder: 'შეიტანეთ ბმულის სახელი',
			},
			url: {
				label: 'URL - მისამართი',
				placeholder: 'http://',
			},
		},
	},
	policy: {
		h1: 'პორტალის გამოყენების წესები',
		p1: 'ძვირფასო კოლეგავ, მოგესალმებით',
		p1_1: 'ინტრანეტ პორტალზე! ',
		p2: 'აქ ჩვენ ყველანი IDS Ukraine -ს თანამშრომლები ვართ, შეგვიძლია გავიგოთ ყველაფერი ჩვენი ჯგუფისა და მისი სტრატეგიის შესახებ, გავუზიაროთ ერთმანეთს სიახლეები,მოვიპოვოთ წვდომა აქტუალურ ინფორმაციასა და სერვისებზე, რომლებიც გვეხმარება მუშაობაში.',
		p3: 'პორტალზე შესვლით, შენ თანხმობას აცხადებ დაიცვა შემდეგი წესები:',
		li1: 'დაიცვა ურთიერთობის ეთიკა და პატივი სცე სხვის აზრს;',
		li2: 'დატოვო პორტალს მიღმა მწვავე სოციალური თემების განხილვა, პირადი საკითხების, ფულისა და ჯანმრთელობის ჩათვლით;',
		li3: 'მისდიო გამჭვირვალეობის პრინციპს და ინფორმაციის გამოქვეყნებისას არ მიმართო ანონიმურობას;',
		li4: 'გახსოვდეს ის, რომ პორტალი განკუთვნილია მხოლოდ თანამშრომლების შიდა გამოყენებისთვის, ანუ შინაარსი არის კონფიდენციალური.',
		li5: 'წერო გრამატიკულად გამართული ენით;',
		li6: 'იყო მზად იმისთვის, რომ პორტალის ადმინისტრაციამ შეიძლება უარი გითხრას გამოქვეყნებაზე. ან წაშალოს კონტენტი პორტალზე, თუ იგი არღვევს ნებისმიერ გახმოვანებულ წესს.',
		p4: '',
		p4_1: ' -ზე მიუღებელია',
		li7: 'არანორმატიული ლექსიკის, უხეში ფრაზების გამოყენება, პიროვნების შეურაცხყოფა, ეროვნული, რელიგიური და ზნეობრივი გრძნობების შელახვა;',
		li8: 'წინასწარი ცნობით ცრუ ინფორმაციის გამოქვეყნება;',
		li9: 'არალიცენზიურ კომერციულ პროგრამულ უზრუნველყოფაზე ბმულების, მისი გატეხვის პროგრამების და გასაღებების გენერატორების გამოქვეყნება  ასევე, საავტორო უფლებებით დაცული მასალების გამოქვეყნება;',
		li10: 'მოდერატორის როლში გამოსვლა: შენიშვნების გაკეთება სხვა მომხმარებლებისთვის შესაბამისი უფლებამოსილებების გარეშე;',
		li11: 'მომხმარებლების, მოდერატორებისა და ადმინისტრაციის  მოქმედებების განხილვა და განსჯა.',
		p5: 'წესების დარღვევისთვის ადმინისტრატორებმა შეიძლება მოახდინონ გაფრთხილება და დაბლოკონ ანგარიში, მაგრამ ჩვენ ამას არ ვისურვებდით.',
		p6: 'ყველა ტექნიკურ საკითხებზე მიმართეთ IT Service Desk',
		p7: 'კონტენტის საკითხებზე Ask IDS Ukraine',
		p8: 'დაე ',
		p8_1: '-ს მოჰქონდეს მხოლოდ სარგებელი მუშაობასა და კომუნიკაციებში!',
		p9: 'შიდა კომუნიკაციების გუნდი',
	},
};

export default locale;
